/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

export enum DocumentType {
  audio_file = 'audio_file',
  pdf = 'pdf',
  video = 'video',
  embed = 'embed'
}
